module.exports = __webpack_public_path__ + "assets/img/page4-nav-item-8-8a355766.png";